// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { DesignStudioWeddingRingNewCustomerResponseFragmentDoc } from '../fragments/designStudioWeddingRingNewCustomerResponse.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const CreateDesignStudioProductAndAddToCartWeddingRingNewCustomerDocument = gql`
    mutation createDesignStudioProductAndAddToCartWeddingRingNewCustomer($input: DesignStudioWeddingRingInput!, $customer: CustomerRegistrationInput!, $isConsultant: Boolean!) {
  createDesignStudioProductAndAddToCartWeddingRingNewCustomer(
    input: $input
    customer: $customer
  ) {
    ...designStudioWeddingRingNewCustomerResponse
  }
}
    ${DesignStudioWeddingRingNewCustomerResponseFragmentDoc}`;

export function useCreateDesignStudioProductAndAddToCartWeddingRingNewCustomerMutation() {
  return Urql.useMutation<SchemaTypes.CreateDesignStudioProductAndAddToCartWeddingRingNewCustomerMutation, SchemaTypes.CreateDesignStudioProductAndAddToCartWeddingRingNewCustomerMutationVariables>(CreateDesignStudioProductAndAddToCartWeddingRingNewCustomerDocument);
};